export const translation = {
  zenit: {
    en: {
      siteTitle: "Refuel for Formula 1",
      rulesBtnText: "Rules",
      titleLine1: "Refuel",
      titleLine2: "for Formula 1",
      titleLine3: `Get to the start`,
      titleLine4: "with free bet",
      titleLine5: "",
      titleLine6: "",
      titleLine7: "",
      btnGet: "TAKE PART",
      conditionSpan1: "log in",
      conditionSpan1Extra: `
     to the site`,
      conditionSpan1Part2: "",
      conditionText1: "",
      conditionSpan2: "Make a deposit",
      conditionText2Extra: "and bet ",
      conditionText2: `
      on Formula 1`,
      conditionExtra3: `Get a free bet`,
      conditionSpan3: "on the account",
      conditionText3: "",
      bkString: "Bookmaker Zenit",
      rightString: "All rights reserved",
      supportText: "Support center:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Terms and conditions of the Promotion",
      paragraph1: '1. The promotion lasts from 18 March  2022 to 20 March 2022',
      paragraph2: '2. The dates of the Promotion are determined by Zenit Bookmaker and may be changed at any time for any reason and without additional notification.',
      paragraph3: '3. The participant of the Promotion must register or log in on the zenitbet.com website during the Promotion period and confirm his participation in the Promotion by clicking on the "Take part" button.',
      paragraph4: '4. The bonus is awarded in the free bet form.',
      paragraph5: '5. Terms of receiving a free bet:',
      paragraph6: '6. Bonuses are not awarded in the following cases:',
      paragraph7: `7. BK Zenit has the right to refuse to charge a free bet to a participant of the Promotion, as well as to suspend a participant from participating in any company's Promotions, invalidate any actions of a participant in respect of whom BK Zenit has reasonable suspicions that he knowingly unfairly exercises the rights to participate in the Promotion or abuses them, distorts data or benefits from any forgery of data necessary to participate in the Promotion, including, but not limited to the following actions:`,
      paragraph8: `8. In case of detection of any of the violations of the rules of the Promotion, BK Zenit has the right to prohibit the participant from receiving free bets, cancel the winnings received using free bets and block the account of the participant of the Promotion.`,
      paragraph9: '9. Terms of use of free bets:',
      paragraph10: '10. In case of winning a bet paid with the amount of the freebet, the participant of the Promotion is paid only the amount of the winnings without taking into account the amount of the freebet. The freebet is not reused.',
      paragraph11: '11. Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      paragraph12: '12. By using the free bet option, you fully agree to these Terms and conditions.',
      tableLeftTopText: 'Number of bonuses per day',
      tableCenterTopText: 'Free bet amount (in currencies)',
      tableCurrencyRUB: 'RUB',
      tableCurrencyUSD: 'USD',
      tableCurrencyEUR: 'EUR',
      tableCurrencyIRR: 'IRR',
      tableCurrencyBRL: 'BRL',
      tableCurrencyUAH: 'UAH',
      tableCurrencyKZT: 'KZT',
      tableCurrencyPRB: 'PRB',
      tableCurrencyTMT: 'TMT',
      tableCurrencyMDL: 'MDL',
      noFreebetText: 'free bet shall not be credited',
      subParagraph31: '3.1. The Promotion is available for users who have registered before 18.03.2022.',
      subParagraph51: `5.1. The Promotion includes bets placed on Formula 1 events on March 20, except for statistics.`,
      subParagraph52: '5.2. The amount of the free bet depends on the size of the first deposit in the period from 18.03.2022 to 20.03.2022. If a Participant makes several deposits during the designated period, the first one that was made after clicking the TAKE PART button is taken into account when calculating the free bet.',
      subParagraph53: '5.3. If the deposit made from 18.03.2022 to 20.03.2022 is less than 100 rubles, the free bet is not provided.',
      subParagraph54: '5.4. Free bets are awarded daily from 00:00 to 03:00 UTC+3.',
      subParagraph61: '6.1. The bet is made on a match or event not from the terms of the Promotion.',
      subParagraph62: '6.2. The bet is made using a free bet.',
      subParagraph63: '6.3. The bet has already been accounted for in other Promotions of the company.',
      subParagraph64: '6.4. The bet was cashed out by the participant of the Promotion. ',
      subParagraph91: '9.1. The free bet can be used after being checked for compliance with the requirements specified in Clause 5 of these Terms and conditions within 7 days.',
      subParagraph92: '9.2. The free bet was made only for the entire amount of the free bet.',
      subParagraphLetter71: 'a) the participant was caught in actions that entailed or may entail adverse consequences of various types and degrees both for BK Zenit and for other participants and for third parties;',
      subParagraphLetter72: 'b) in case of revealing the fact that the participant has provided information that does not correspond to reality;',
      subParagraphLetter73: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraphLetter74: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraphLetter75: `e) the Participant's account has been blocked.`,
    },
    ru: {
      siteTitle: "Заправляйся к «Формуле-1»",
      rulesBtnText: "Правила",
      titleLine1: "Заправляйся",
      titleLine2: "к «Формуле-1»",
      titleLine3: `Выходи на старт  `,
      titleLine4: "с фрибетом",
      btnGet: "Участвовать",
      conditionSpan1: `Авторизуйся`,
      conditionText1: "на сайте",
      conditionSpan2: `Внеси депозит`,
      conditionText2: `
      и поставь на 
      «Формулу-1»`,
      conditionSpan3: `Получи фрибет`,
      conditionText3: "на счёт",
      specialCondition: "Всё",
      bkString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      supportText: "Служба поддержки:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится с 18.03.2022 г. по 20.03.2022 г. ',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции авторизоваться на сайте zenitbet.com, а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать»',
      paragraph4: '4. Бонус  начисляется в виде фрибета.',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Бонусы не начисляются в следующих случаях:',
      paragraph7: '7. БК «Зенит»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:\n',
      paragraph8: '8. В случае обнаружения любого из нарушений правил Акции БК «Зенит»  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph9: '9. Условия использования фрибетов:',
      paragraph10: '10. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph11: '11. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph12: '12. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText: 'Сумма депозита (диапазон)',
      tableCenterTopText: 'Сумма бесплатной ставки (фрибет) в валюте',
      tableCurrencyRUB: 'RUB',
      tableCurrencyUSD: 'USD',
      tableCurrencyEUR: 'EUR',
      tableCurrencyIRR: 'IRR',
      tableCurrencyBRL: 'BRL',
      tableCurrencyUAH: 'UAH',
      tableCurrencyKZT: 'KZT',
      tableCurrencyPRB: 'PRB',
      tableCurrencyTMT: 'TMT',
      tableCurrencyMDL: 'MDL',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph31: "3.1 В Акции могут принимать участие пользователи, зарегистрировавшиеся до 18.03.2022.",
      subParagraph51: '5.1. В Акции участвуют ставки, сделанные на события Формулы-1 20 марта, кроме статистики.',
      subParagraph52: '5.2. Сумма фрибета зависит от размера первого депозита в период с 18.03.2022 по 20.03.2022. Если в обозначенный период Участник вносит несколько депозитов, то при расчете фрибета учитывается первый, который был внесен после нажатия кнопки УЧАСТВОВАТЬ.',
      subParagraph53: '5.3. Если депозит, внесенный с 18.03.2022 по 20.03.2022, меньше 100 рублей, бесплатная ставка не выдается.',
      subParagraph54: '5.4. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3',
      subParagraph61: '6.1. Ставка сделана на матч или событие не из условий Акции.',
      subParagraph62: '6.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph63: '6.3. Ставка уже была учтена в других акциях компании.',
      subParagraph64: '6.4. Ставка была продана участником Акции.',
      subParagraph91: '9.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.',
      subParagraph92: '9.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит» , так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.'
    },
  },
  zenbet: {
    en: {
      siteTitle: "Refuel for Formula 1",
      rulesBtnText: "Rules",
      titleLine1: "Refuel",
      titleLine2: "for Formula 1",
      titleLine3: `Get to the start`,
      titleLine4: "with free bet",
      titleLine5: "",
      titleLine6: "",
      titleLine7: "",
      btnGet: "TAKE PART",
      conditionSpan1: "log in",
      conditionSpan1Extra: `
     to the site`,
      conditionSpan1Part2: "",
      conditionText1: "",
      conditionSpan2: "Make a deposit",
      conditionText2Extra: "and bet ",
      conditionText2: `
      on Formula 1`,
      conditionExtra3: `Get a free bet`,
      conditionSpan3: "on the account",
      conditionText3: "",
      bkString: "Bookmaker ZENBET",
      rightString: "All rights reserved",
      supportText: "Support center:",
      supportSpan: "support@zen.bet",
      rulesHeaderText: "Terms and conditions of the Promotion",
      paragraph1: '1. The promotion lasts from 18 March  2022 to 20 March 2022',
      paragraph2: '2. The dates of the Promotion are determined by ZENBET Bookmaker and may be changed at any time for any reason and without additional notification.',
      paragraph3: '3. The participant of the Promotion must register or log in on the zen.bet website during the Promotion period and confirm his participation in the Promotion by clicking on the "Take part" button.',
      paragraph4: '4. The bonus is awarded in the free bet form.',
      paragraph5: '5. Terms of receiving a free bet:',
      paragraph6: '6. Bonuses are not awarded in the following cases:',
      paragraph7: `7. BK ZENBET has the right to refuse to charge a free bet to a participant of the Promotion, as well as to suspend a participant from participating in any company's Promotions, invalidate any actions of a participant in respect of whom BK ZENBET has reasonable suspicions that he knowingly unfairly exercises the rights to participate in the Promotion or abuses them, distorts data or benefits from any forgery of data necessary to participate in the Promotion, including, but not limited to the following actions:`,
      paragraph8: `8. In case of detection of any of the violations of the rules of the Promotion, BK ZENBET has the right to prohibit the participant from receiving free bets, cancel the winnings received using free bets and block the account of the participant of the Promotion.`,
      paragraph9: '9. Terms of use of free bets:',
      paragraph10: '10. In case of winning a bet paid with the amount of the freebet, the participant of the Promotion is paid only the amount of the winnings without taking into account the amount of the freebet. The freebet is not reused.',
      paragraph11: '11. Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      paragraph12: '12. By using the free bet option, you fully agree to these Terms and conditions.',
      tableLeftTopText: 'Number of bonuses per day',
      tableCenterTopText: 'Free bet amount (in currencies)',
      tableCurrencyRUB: 'RUB',
      tableCurrencyUSD: 'USD',
      tableCurrencyEUR: 'EUR',
      tableCurrencyIRR: 'IRR',
      tableCurrencyBRL: 'BRL',
      tableCurrencyUAH: 'UAH',
      tableCurrencyKZT: 'KZT',
      tableCurrencyPRB: 'PRB',
      tableCurrencyTMT: 'TMT',
      tableCurrencyMDL: 'MDL',
      noFreebetText: 'free bet shall not be credited',
      subParagraph31: '3.1. The Promotion is available for users who have registered before 18.03.2022.',
      subParagraph51: `5.1. The Promotion includes bets placed on Formula 1 events on March 20, except for statistics.`,
      subParagraph52: '5.2. The amount of the free bet depends on the size of the first deposit in the period from 18.03.2022 to 20.03.2022. If a Participant makes several deposits during the designated period, the first one that was made after clicking the TAKE PART button is taken into account when calculating the free bet.',
      subParagraph53: '5.3. If the deposit made from 18.03.2022 to 20.03.2022 is less than 100 rubles, the free bet is not provided.',
      subParagraph54: '5.4. Free bets are awarded daily from 00:00 to 03:00 UTC+3.',
      subParagraph61: '6.1. The bet is made on a match or event not from the terms of the Promotion.',
      subParagraph62: '6.2. The bet is made using a free bet.',
      subParagraph63: '6.3. The bet has already been accounted for in other Promotions of the company.',
      subParagraph64: '6.4. The bet was cashed out by the participant of the Promotion. ',
      subParagraph91: '9.1. The free bet can be used after being checked for compliance with the requirements specified in Clause 5 of these Terms and conditions within 7 days.',
      subParagraph92: '9.2. The free bet was made only for the entire amount of the free bet.',
      subParagraphLetter71: 'a) the participant was caught in actions that entailed or may entail adverse consequences of various types and degrees both for BK ZENBET and for other participants and for third parties;',
      subParagraphLetter72: 'b) in case of revealing the fact that the participant has provided information that does not correspond to reality;',
      subParagraphLetter73: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraphLetter74: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraphLetter75: `e) the Participant's account has been blocked.`,
    },
    ru: {
      siteTitle: "Заправляйся к «Формуле-1»",
      rulesBtnText: "Правила",
      titleLine1: "Заправляйся",
      titleLine2: "к «Формуле-1»",
      titleLine3: `Выходи на старт  `,
      titleLine4: "с фрибетом",
      titleLine5: "",
      titleLine6: "",
      // titleLine7: "₽",
      btnGet: "Участвовать",
      conditionSpan1: `Авторизуйся`,
      conditionSpan1Extra: ``,
      conditionText1: "на сайте",
      conditionSpan2: `Внеси депозит`,
      conditionText2: `
      и поставь на 
      «Формулу-1»`,
      conditionSpan3: `Получи фрибет`,
      conditionText3: "на счёт",
      specialCondition: "Всё",
      bkString: "Букмекерская контора «ZENBET»",
      note: "",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Служба поддержки:",
      supportSpan: "support@zen.bet",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится с 18.03.2022 г. по 20.03.2022 г. ',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «ZENBET» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции авторизоваться на сайте zen.bet, а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать»',
      paragraph4: '4. Бонус  начисляется в виде фрибета.',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Бонусы не начисляются в следующих случаях:',
      paragraph7: '7. БК «ZENBET»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «ZENBET» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:\n',
      paragraph8: '8. В случае обнаружения любого из нарушений правил Акции БК «ZENBET»  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph9: '9. Условия использования фрибетов:',
      paragraph10: '10. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph11: '11. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph12: '12. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText: 'Сумма депозита (диапазон)',
      tableCenterTopText: 'Сумма бесплатной ставки (фрибет) в валюте',
      tableCurrencyRUB: 'RUB',
      tableCurrencyUSD: 'USD',
      tableCurrencyEUR: 'EUR',
      tableCurrencyIRR: 'IRR',
      tableCurrencyBRL: 'BRL',
      tableCurrencyUAH: 'UAH',
      tableCurrencyKZT: 'KZT',
      tableCurrencyPRB: 'PRB',
      tableCurrencyTMT: 'TMT',
      tableCurrencyMDL: 'MDL',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph31: "3.1 В Акции могут принимать участие пользователи, зарегистрировавшиеся до 18.03.2022.",
      subParagraph51: '5.1. В Акции участвуют ставки, сделанные на события Формулы-1 20 марта, кроме статистики.',
      subParagraph52: '5.2. Сумма фрибета зависит от размера первого депозита в период с 18.03.2022 по 20.03.2022. Если в обозначенный период Участник вносит несколько депозитов, то при расчете фрибета учитывается первый, который был внесен после нажатия кнопки УЧАСТВОВАТЬ.',
      subParagraph53: '5.3. Если депозит, внесенный с 18.03.2022 по 20.03.2022, меньше 100 рублей, бесплатная ставка не выдается.',
      subParagraph54: '5.4. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3',
      subParagraph61: '6.1. Ставка сделана на матч или событие не из условий Акции.',
      subParagraph62: '6.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph63: '6.3. Ставка уже была учтена в других акциях компании.',
      subParagraph64: '6.4. Ставка была продана участником Акции.',
      subParagraph91: '9.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.',
      subParagraph92: '9.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «ZENBET» , так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.'
    },
  },
  cupis: {
    ru: {
      siteTitle: "Заправляйся к «Формуле-1»",
      rulesBtnText: "Правила",
      titleLine1: "Заправляйся",
      titleLine2: "к\u00A0«Формуле-1»",
      titleLine3: `Выходи на старт  `,
      titleLine4: "с фрибетом",
      titleLine5: "",
      titleLine6: "",
      // titleLine7: "₽",
      btnGet: "Участвовать",
      conditionSpan1: `Авторизуйся`,
      conditionSpan1Extra: ``,
      conditionText1: "на\u00A0сайте",
      conditionSpan2: `Внеси\u00A0депозит`,
      conditionText2: `
      и поставь на 
      «Формулу-1»`,
      conditionSpan3: `Получи\u00A0фрибет`,
      conditionText3: "на\u00A0счёт",
      specialCondition: "Всё",
      bkString: "Букмекерская контора «Зенит»",
      note: "",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Служба поддержки:",
      supportSpan: "8 (800) 222-55-50",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится с 18.03.2022 г. по 20.03.2022 г. ',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции авторизоваться на сайте zenit.win, а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать»',
      paragraph4: '4. Бонус  начисляется в виде фрибета.',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Бонусы не начисляются в следующих случаях:',
      paragraph7: '7. БК «Зенит»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:\n',
      paragraph8: '8. В случае обнаружения любого из нарушений правил Акции БК «Зенит»  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph9: '9. Условия использования фрибетов:',
      paragraph10: '10. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph11: '11. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph12: '12. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText: 'Сумма депозита (диапазон)',
      tableCenterTopText: 'Сумма бесплатной ставки (фрибет) в рублях',
      tableCurrencyRUB: 'RUB',
      tableCurrencyUSD: 'USD',
      tableCurrencyEUR: 'EUR',
      tableCurrencyIRR: 'IRR',
      tableCurrencyBRL: 'BRL',
      tableCurrencyUAH: 'UAH',
      tableCurrencyKZT: 'KZT',
      tableCurrencyPRB: 'PRB',
      tableCurrencyTMT: 'TMT',
      tableCurrencyMDL: 'MDL',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph31: "3.1 В Акции могут принимать участие пользователи, зарегистрировавшиеся до 18.03.2022.",
      subParagraph51: '5.1. В Акции участвуют ставки, сделанные на события Формулы-1 20 марта, кроме статистики.',
      subParagraph52: '5.2. Сумма фрибета зависит от размера первого депозита в период с 18.03.2022 по 20.03.2022. Если в обозначенный период Участник вносит несколько депозитов, то при расчете фрибета учитывается первый, который был внесен после нажатия кнопки УЧАСТВОВАТЬ.',
      subParagraph53: '5.3. Если депозит, внесенный с 18.03.2022 по 20.03.2022, меньше 100 рублей, бесплатная ставка не выдается.',
      subParagraph54: '5.4. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3',
      subParagraph61: '6.1. Ставка сделана на матч или событие не из условий Акции.',
      subParagraph62: '6.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph63: '6.3. Ставка уже была учтена в других акциях компании.',
      subParagraph64: '6.4. Ставка была продана участником Акции.',
      subParagraph91: '9.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.',
      subParagraph92: '9.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит» , так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.'
    }
  }
}
